/**
 * @generated SignedSource<<e1319b359c54e5edab345d42d0f05a74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EntitySidebar_entity$data = {
  readonly createdAt: string | null;
  readonly updatedAt: string | null;
  readonly uuid: string;
  readonly " $fragmentType": "EntitySidebar_entity";
};
export type EntitySidebar_entity$key = {
  readonly " $data"?: EntitySidebar_entity$data;
  readonly " $fragmentSpreads": FragmentRefs<"EntitySidebar_entity">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EntitySidebar_entity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "Entity",
  "abstractKey": "__isEntity"
};

(node as any).hash = "f1c4d892e8431ecb6928c076997ba660";

export default node;
